// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductCreatePage_container__1aprt"};